import React, { useEffect, useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useAccount } from 'wagmi';
import { CopyToClipboard } from "react-copy-to-clipboard";
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import { isMobile } from 'react-device-detect';
import { useReferralStats } from '../hooks/useBscCommon';

export default function ReferralShare({ accStats }) {
    const { address } = useAccount();
    const [referrallink, setReferrallink] = useState(
        "Please connect your wallet"
    );
    const [refcopy, setRefcopy] = useState(false);
    let base_url = `${window.location.origin}?ref=`;
    const refStats = useReferralStats();


    useEffect(() => {
        if (address) {
            setReferrallink(`${base_url}${address}`);
        } else {
            setReferrallink("Please connect your wallet");
        }
    }, [address, base_url]);

    return (
        <div className='row mt-4 mb-5 d-flex justify-content-center'>
            <div className='col-sm-12 col-xl-11 col-lg-11'>
                <div className='card'>
                    <div class="ref-main text-center text-white">
                        <article class="presentation">
                            <h2 class="page-title text-white">Refer Friends.Earn Reward</h2>
                            <p class="description">Earn up to 10% commission on every earn.</p>
                        </article>
                        <div class="input-group mx-3 my-3 d-flex justify-content-center">
                            <input type="text" className="ref-input" value={referrallink} readOnly={true} />
                            <span class="input-group-text" id="basic-addon2">
                                <CopyToClipboard text={`${base_url}${address}`} onCopy={() => {
                                    setRefcopy(true);
                                    setTimeout(() => {
                                        setRefcopy(false);
                                    }, 2000)
                                }}>
                                    {refcopy ? (
                                        <ContentPasteIcon sx={{ color: "#fff" }} fontSize="small" />
                                    ) : (
                                        <ContentCopyIcon sx={{ color: "#fff" }} fontSize="small" />

                                    )}
                                </CopyToClipboard>
                            </span>
                        </div>

                        <div class="d-flex justify-content-center">
                            {refStats.level && refStats.level.length > 0 && refStats.level.map((items, key) => (

                                isMobile ? (
                                    <div class="description ref-per mx-2 bd-highlight level-span fs-12" key={key} > LV{key + 1} &nbsp; :&nbsp; {items}%</div>
                                ) : (
                                    <div class="description ref-per mx-2 bd-highlight level-span" key={key}>Level {key + 1} &nbsp; :&nbsp; {items}%</div>
                                )

                            ))}

                        </div>
                        {address &&
                            <>
                                <h5 className='my-2'>Your Referral Count</h5>
                                <div class="d-flex justify-content-center">
                                    {accStats.refLevelCount && accStats.refLevelCount.length > 0 && accStats.refLevelCount.map((items, key) => (

                                        isMobile ? (
                                            <div class="description ref-per mx-2 bd-highlight level-span fs-12" key={key} > LV{key + 1} &nbsp; :&nbsp; {items}</div>
                                        ) : (
                                            <div class="description ref-per mx-2 bd-highlight level-span" key={key}>Level {key + 1} &nbsp; :&nbsp; {items}</div>
                                        )

                                    ))}

                                </div>
                            </>
                        }
                    </div>

                </div>
            </div>
        </div >
    )
}
